module.exports = __webpack_public_path__ + "f46e0914dc9f5cbd817531aca07bf998.fbx";